<div class="no-content-component">
  <div class="icon-store">
    <mat-icon>store</mat-icon>
  </div>
  <p class="center-mobile">{{'secure.offers.stores.txt_no_seller' | translate}}</p>
</div>
